import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { ExcessUsersBanner as Web5ExcessUsersBanner } from '@Sage/ssm-web5';

import Context from 'managers/Context';
import { ADMIN_URL } from 'constants/Environment';

const ExcessUsersBanner = () => {
    const {
        canConfigImplementation,
        manageUsersFromWeb,
        subscriptionModeCode,
        totalBillableUsers,
        purchasedLicenseRaw,
    } = useSelector((state) => {
        const userData = state.config?.userData ?? {};
        return {
            canConfigImplementation: state.config?.permission?.canConfigImplementation,
            manageUsersFromWeb: userData.manageUsersFromWeb,
            subscriptionModeCode: state.config?.subscriptionModeCode,
            totalBillableUsers: userData.totalBillableUsers,
            purchasedLicenseRaw: userData.purchasedLicenses,
        };
    });

    const isFreeImpl = !!subscriptionModeCode?.includes('free');
    const purchased = purchasedLicenseRaw ? parseInt(purchasedLicenseRaw, 10) : undefined;
    const billable = totalBillableUsers ? parseInt(totalBillableUsers, 10) : undefined;

    const enabled =
        !isFreeImpl &&
        Number.isFinite(purchased) &&
        purchased > 0 &&
        Number.isFinite(billable) &&
        billable > purchased;

    const href = canConfigImplementation
        ? manageUsersFromWeb
            ? '#/settings/users'
            : `${ADMIN_URL}?token=${Context?.config?.token}&entityToGo=users`
        : null;

    if (!enabled) return null;

    return (
        <Web5ExcessUsersBanner
            enabled={enabled}
            totalBillableUsers={billable}
            totalUsersPurchased={purchased}
            href={href}
            linkTarget="_blank"
            linkRel="noreferrer"
        />
    );
};

export default memo(ExcessUsersBanner);
